var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-crm-status-select',{attrs:{"fancy":"","multi":_vm.multi,"value":_vm.val,"label":_vm.label},on:{"input":function($event){return _vm.setValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }